var _g;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPlayButtonOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 103 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71675 11.5606L10.2443 7.415C10.5206 7.20772 10.5206 6.79315 10.2443 6.58587L4.71675 2.44023C4.37513 2.18402 3.88762 2.42777 3.88762 2.8548L3.88762 11.1461C3.88762 11.5731 4.37513 11.8169 4.71675 11.5606ZM11.177 8.65869L5.64952 12.8043C4.28304 13.8292 2.33301 12.8542 2.33301 11.1461L2.33301 2.8548C2.33301 1.1467 4.28304 0.17168 5.64952 1.19654L11.177 5.34218C12.2825 6.17131 12.2825 7.82956 11.177 8.65869Z",
    fill: "var(--secondary-7)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonOutlined);
export default __webpack_public_path__ + "static/media/playButtonOutlined.d672ec6de0c6c82c30c4301129b0b443.svg";
export { ForwardRef as ReactComponent };